import React from 'react';
import {LayoutDispatcher} from './LayoutProviderReducer';

export function setContextCollapsed(dispatch:React.Dispatch<LayoutDispatcher>) {
    dispatch({ type: 'COLLAPSED'});
  return;
}

export function setContextIsSmallScreen(isSmallScreen:boolean, dispatch:React.Dispatch<LayoutDispatcher>) {
    dispatch({ type: 'IS_SMALL_SCREEN', payload: { isSmallScreen: isSmallScreen }});
}


